<template>
    <div>
      <vs-dropdown style="margin-left: 5px; cursor: pointer;" vs-custom-content vs-trigger-click>
        <vs-button color="primary" type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>
  
        <vs-dropdown-menu style="min-width: 100px;">
          <vs-dropdown-item v-if="params.colDef.CellRendererParams.checkEditPermission()" @click="params.colDef.CellRendererParams.templateEditSidebar(params.data)">Edit</vs-dropdown-item>
          <vs-dropdown-item v-if="params.colDef.CellRendererParams.checkDeletePermission()" @click="params.colDef.CellRendererParams.templateDeletePopup(params.data)">Delete</vs-dropdown-item>
          <vs-dropdown-item v-if="params.colDef.CellRendererParams.checkEditPermission()" @click="showMarkPopUpBool = !showMarkPopUpBool">Mark as default</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <vs-popup
        classContent="popup-example"
        title="Please Confirm"
        :active.sync="showMarkPopUpBool"
      >
        <h4>Are you sure to mark this signature as default ?</h4>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
          <vs-button class="mr-2" @click="signatureMarkAsDefault(params.data)">Confirm</vs-button>
          <vs-button type="border" color="danger" @click="showMarkPopUpBool = false"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
    </div>
  </template>
  
  <script>
  import { emailSignatureEdit } from '@/api/email'
  export default {
    name: 'TemplateActionCell',
    methods: {
      async signatureMarkAsDefault (signature_data) {
        if (signature_data.is_default === 1) {
          this.$vs.notify({
            title: 'Warning',
            text: 'Already marked as default',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
          return false
        }
        this.$vs.loading()
        const emailPayload = {
          title: signature_data.title,
          desc: signature_data.desc,
          body: signature_data.body,
          is_default: signature_data.is_default ? 0 : 1
        }
        try {
          await emailSignatureEdit(
            signature_data.customer_id,
            signature_data.id,
            emailPayload
          )
          this.params.context.componentParent.closeNfetch()
          this.showMarkPopUpBool = false
          this.$vs.notify({
            title: 'Success',
            text: `Marked as default`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            time: 3000
          })
        } catch (error) {
          this.$vs.notify({
            title: 'Error',
            text: 'Failed',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
        } finally {
          this.$vs.loading.close()
        }
      },
    },
    data() {
      return {
        showMarkPopUpBool: false
      }
    }
  }
  </script>